import { ApiRequest as ApiRequestWorker } from "./base.worker";
import { ApiRequest as ApiRequestFallback } from "./base.fallback";

// const ApiRequest = typeof window.Worker === 'undefined' ? ApiRequestFallback : ApiRequestWorker;
const ApiRequest = ApiRequestFallback; // Force fallback for now (fetch)

export { ApiRequest };